const passwordResetParams = [
    "p=B2C_1_password_reset_ng",
    "nonce=defaultNonce",
    "scope=openid",
    "response_type=id_token",
    "prompt=login"
];

const checkVentory = {
    local: {
        api: {
            url: "https://checkventory-qa-api-man.azure-api.net/client-api"
        },
        auth: {
            url: "https://auth-qa.checkventory.com"
        },
        clientId: "b66b7af5-c464-4a9c-ad77-a596675f44bf",
        allowedDistanceRange: 2,
        googleMaps: {
            apiKey: "AIzaSyDCR_1WKGsdDHsGmcF8Om51JmQhs9YWds8"
        },
        csvBox: {
            licenceKey: "BcH0VlRUSyyNFcF1WMdtkIrmZ7KSwQ"
        },
        // Azure B2C MSAL Config
        azureB2C: {
            clientId: "b66b7af5-c464-4a9c-ad77-a596675f44bf",
            tenant: "checkventoryadb2cqa", // B2C tenant name
            tenantDomain: "checkventoryadb2cqa.onmicrosoft.com",
            signInFlow: "B2C_1_SIGN_IN", // Modern interactive sign-in flow
            resetPasswordFlow: "B2C_1_password_reset_ng",
            editProfileFlow: "B2C_1_edit_profile" // Optional
        },
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https%3A%2F%2Fauditor-qa.checkventory.com",
            url: "https://checkventoryadb2cqa.b2clogin.com/checkventoryadb2cqa.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "b6aeea82-334e-46f4-87d5-12e2e1250273",
                datasetId: "691e6053-c213-4d8b-afe0-4619f9371d7b"
            },
            reports: [
                {
                    label: "auditOverview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "38807d69-3ccd-4073-81c1-31f97db19341",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                    //send_identities: "none"
                },
                {
                    label: "auditDetails",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "47d44384-678f-4abb-accf-af44b0be8fa4",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                    //send_identities: "none"
                },
                {
                    label: "orgOrientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "ce8aad97-6f42-489c-ad8f-ec8be666cbd3",
                    datasetId: "5b98f105-9a07-43fa-b731-65a902eb33e3"
                    //send_identities: "none"
                },
                {
                    label: "assetLookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "72a34df9-1144-43ea-8bfc-8754070cf27f",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                    //send_identities: "none"
                },
                {
                    label: "funderConnect",
                    tabValue: 4,
                    visuals: null,
                    reportId: "a61045bd-88ec-4baa-8189-14d09df521a1",
                    datasetId: "3a65919b-e0d5-4a45-9373-954738e6f30d"
                    //send_identities: "none"
                },
                {
                    label: "auditOutcome",
                    tabValue: 5,
                    visuals: null,
                    reportId: [
                        "f4f5fdec-aec7-42ef-afaa-53f14d64e2d7",
                        "928e67d1-c4bc-4a54-a57c-da172b01785b"
                    ],
                    datasetId: "f6c60e16-d7ee-49b3-81d6-f0fe6c39ad31",
                    send_identities: false
                },
                {
                    label: "atRiskAsset",
                    tabValue: 6,
                    visuals: null,
                    reportId: "5e5233a5-05f2-491e-9c7b-9d8569222adc",
                    datasetId: "c144bd0a-87f6-46fa-b397-35fd572b55ea"
                }
            ],
            operations: [
                {
                    label: "onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "e8c15d8a-08f4-4a54-92a7-4eeac07e2eeb",
                    datasetId: "325fe4c3-af07-4e09-b09d-e1ca56c001a3"
                },
                {
                    label: "servicePerformance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "d3f628c2-56c8-49c9-96d4-a4b34d75af4c",
                    datasetId: "76dc6b46-6edb-418f-b58d-b2499e0aae52"
                },
                {
                    label: "billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "8035625a-0887-45d2-a771-e5f407f13b8c",
                    datasetId: "7419154e-45f5-4787-baa2-d2687de30a7b"
                },
                {
                    label: "auditPerformance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "37155a01-1236-4a94-91f3-f8ad75e14948",
                    datasetId: "303dab09-a733-4511-8e1a-fd871273c149"
                },
                {
                    label: "compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "2d7195f9-2fd7-44ab-8932-8faa9e2e92b6",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                },
                {
                    label: "invoice",
                    tabValue: 5,
                    visuals: null,
                    reportId: "6780cac1-a274-42ee-be26-3fa969314cf9",
                    datasetId: "10bc9d11-1c91-45cc-8136-ae3be7973b26"
                }
            ],
            funderCheck: {
                reportId: "e44196c8-d398-4e6b-ae46-a199306efb1a",
                datasetId: "9f923f71-d5ba-4009-8bf4-5112131c5690"
            }
        },
        supportEmail: "support@checkventory.com"
    },
    dev: {
        api: {
            url: "https://api-dev.checkventory.com"
        },
        auth: {
            url: "https://auth-dev.checkventory.com"
        },
        clientId: "a63ac432-571e-492a-a323-87f9484c1b48",
        allowedDistanceRange: 2,
        googleMaps: {
            apiKey: "AIzaSyDCR_1WKGsdDHsGmcF8Om51JmQhs9YWds8"
        },
        csvBox: {
            licenceKey: "BcH0VlRUSyyNFcF1WMdtkIrmZ7KSwQ"
        },
        // Azure B2C MSAL Config
        azureB2C: {
            clientId: "a63ac432-571e-492a-a323-87f9484c1b48",
            tenant: "checkventoryadb2cdev", // B2C tenant name
            tenantDomain: "checkventoryadb2cdev.onmicrosoft.com",
            signInFlow: "B2C_1_SIGN_IN", // Modern interactive sign-in flow
            resetPasswordFlow: "B2C_1_password_reset_ng",
            editProfileFlow: "B2C_1_edit_profile" // Optional
        },
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https%3A%2F%2Fauditor-dev.checkventory.com",
            url: "https://checkventoryadb2cdev.b2clogin.com/checkventoryadb2cdev.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "b6aeea82-334e-46f4-87d5-12e2e1250273",
                datasetId: "691e6053-c213-4d8b-afe0-4619f9371d7b"
            },
            reports: [
                {
                    label: "Audit Overview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "184c018e-f27e-4564-9fcd-780cf70d6526",
                    datasetId: "b54f93fe-9076-4951-aeb3-d35892e63f11"
                },
                {
                    label: "Audit Details",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "d98fd43e-1baa-4909-877c-e3c395f92413",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                },
                {
                    label: "Org Orientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "ce8aad97-6f42-489c-ad8f-ec8be666cbd3",
                    datasetId: "5b98f105-9a07-43fa-b731-65a902eb33e3"
                },
                {
                    label: "Asset Lookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "72a34df9-1144-43ea-8bfc-8754070cf27f",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                },
                {
                    label: "Funder Connect",
                    tabValue: 4,
                    visuals: null,
                    reportId: "a61045bd-88ec-4baa-8189-14d09df521a1",
                    datasetId: "3a65919b-e0d5-4a45-9373-954738e6f30d"
                },
                {
                    label: "Audit Outcome",
                    tabValue: 5,
                    visuals: null,
                    reportId: [
                        "f4f5fdec-aec7-42ef-afaa-53f14d64e2d7",
                        "928e67d1-c4bc-4a54-a57c-da172b01785b"
                    ],
                    datasetId: "f6c60e16-d7ee-49b3-81d6-f0fe6c39ad31",
                    send_identities: false
                },
                {
                    label: "atRiskAsset",
                    tabValue: 6,
                    visuals: null,
                    reportId: "5e5233a5-05f2-491e-9c7b-9d8569222adc",
                    datasetId: "c144bd0a-87f6-46fa-b397-35fd572b55ea"
                }
            ],
            operations: [
                {
                    label: "Onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "e8c15d8a-08f4-4a54-92a7-4eeac07e2eeb",
                    datasetId: "325fe4c3-af07-4e09-b09d-e1ca56c001a3"
                },
                {
                    label: "Service Performance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "d3f628c2-56c8-49c9-96d4-a4b34d75af4c",
                    datasetId: "76dc6b46-6edb-418f-b58d-b2499e0aae52"
                },
                {
                    label: "Billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "8035625a-0887-45d2-a771-e5f407f13b8c",
                    datasetId: "7419154e-45f5-4787-baa2-d2687de30a7b"
                },
                {
                    label: "Audit Performance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "37155a01-1236-4a94-91f3-f8ad75e14948",
                    datasetId: "303dab09-a733-4511-8e1a-fd871273c149"
                },
                {
                    label: "Compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "2d7195f9-2fd7-44ab-8932-8faa9e2e92b6",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                },
                {
                    label: "Invoice",
                    tabValue: 5,
                    visuals: null,
                    reportId: "6780cac1-a274-42ee-be26-3fa969314cf9",
                    datasetId: "10bc9d11-1c91-45cc-8136-ae3be7973b26"
                }
            ],
            funderCheck: {
                reportId: "e44196c8-d398-4e6b-ae46-a199306efb1a",
                datasetId: "9f923f71-d5ba-4009-8bf4-5112131c5690"
            }
        },
        supportEmail: "support@checkventory.com"
    },
    qa: {
        api: {
            url: "https://checkventory-qa-api-man.azure-api.net/client-api"
        },
        auth: {
            url: "https://auth-qa.checkventory.com"
        },
        clientId: "b66b7af5-c464-4a9c-ad77-a596675f44bf",
        allowedDistanceRange: 2,
        googleMaps: {
            apiKey: "AIzaSyDCR_1WKGsdDHsGmcF8Om51JmQhs9YWds8"
        },
        csvBox: {
            licenceKey: "BcH0VlRUSyyNFcF1WMdtkIrmZ7KSwQ"
        },
        // Azure B2C MSAL Config
        azureB2C: {
            clientId: "b66b7af5-c464-4a9c-ad77-a596675f44bf",
            tenant: "checkventoryadb2cqa", // B2C tenant name
            tenantDomain: "checkventoryadb2cqa.onmicrosoft.com",
            signInFlow: "B2C_1_SIGN_IN", // Modern interactive sign-in flow
            resetPasswordFlow: "B2C_1_password_reset_ng",
            editProfileFlow: "B2C_1_edit_profile" // Optional
        },
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https%3A%2F%2Fauditor-qa.checkventory.com",
            url: "https://checkventoryadb2cqa.b2clogin.com/checkventoryadb2cqa.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "b6aeea82-334e-46f4-87d5-12e2e1250273",
                datasetId: "691e6053-c213-4d8b-afe0-4619f9371d7b"
            },
            reports: [
                {
                    label: "Audit Overview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "38807d69-3ccd-4073-81c1-31f97db19341",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                },
                {
                    label: "Audit Details",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "47d44384-678f-4abb-accf-af44b0be8fa4",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                },
                {
                    label: "Org Orientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "ce8aad97-6f42-489c-ad8f-ec8be666cbd3",
                    datasetId: "5b98f105-9a07-43fa-b731-65a902eb33e3"
                },
                {
                    label: "Asset Lookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "72a34df9-1144-43ea-8bfc-8754070cf27f",
                    datasetId: "eb2d963f-0de4-4312-a121-dcad24269f04"
                },
                {
                    label: "Funder Connect",
                    tabValue: 4,
                    visuals: null,
                    reportId: "a61045bd-88ec-4baa-8189-14d09df521a1",
                    datasetId: "3a65919b-e0d5-4a45-9373-954738e6f30d"
                },
                {
                    label: "Audit Outcome",
                    tabValue: 5,
                    visuals: null,
                    reportId: [
                        "f4f5fdec-aec7-42ef-afaa-53f14d64e2d7",
                        "928e67d1-c4bc-4a54-a57c-da172b01785b"
                    ],
                    datasetId: "f6c60e16-d7ee-49b3-81d6-f0fe6c39ad31",
                    send_identities: false
                },
                {
                    label: "atRiskAsset",
                    tabValue: 6,
                    visuals: null,
                    reportId: "5e5233a5-05f2-491e-9c7b-9d8569222adc",
                    datasetId: "c144bd0a-87f6-46fa-b397-35fd572b55ea"
                }
            ],
            operations: [
                {
                    label: "Onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "e8c15d8a-08f4-4a54-92a7-4eeac07e2eeb",
                    datasetId: "325fe4c3-af07-4e09-b09d-e1ca56c001a3"
                },
                {
                    label: "Service Performance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "d3f628c2-56c8-49c9-96d4-a4b34d75af4c",
                    datasetId: "76dc6b46-6edb-418f-b58d-b2499e0aae52"
                },
                {
                    label: "Billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "8035625a-0887-45d2-a771-e5f407f13b8c",
                    datasetId: "7419154e-45f5-4787-baa2-d2687de30a7b"
                },
                {
                    label: "Audit Performance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "37155a01-1236-4a94-91f3-f8ad75e14948",
                    datasetId: "303dab09-a733-4511-8e1a-fd871273c149"
                },
                {
                    label: "Compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "2d7195f9-2fd7-44ab-8932-8faa9e2e92b6",
                    datasetId: "2aaabcc0-6965-49d2-af17-96130a21a8c2"
                },
                {
                    label: "Invoice",
                    tabValue: 5,
                    visuals: null,
                    reportId: "6780cac1-a274-42ee-be26-3fa969314cf9",
                    datasetId: "10bc9d11-1c91-45cc-8136-ae3be7973b26"
                }
            ],
            funderCheck: {
                reportId: "e44196c8-d398-4e6b-ae46-a199306efb1a",
                datasetId: "9f923f71-d5ba-4009-8bf4-5112131c5690"
            }
        },
        supportEmail: "support@checkventory.com"
    },
    prod: {
        api: {
            url: "https://api-man.checkventory.com/client-api"
        },
        auth: {
            url: "https://auth.checkventory.com"
        },
        clientId: "e33893c0-50dd-482c-b51c-e8c3f460f534",
        allowedDistanceRange: 2,
        googleMaps: {
            apiKey: "AIzaSyDCR_1WKGsdDHsGmcF8Om51JmQhs9YWds8"
        },
        csvBox: {
            licenceKey: "hS56qY7jtFk9Q7WkTJw1PW0VDNL0Qk"
        },
        // Azure B2C MSAL Config
        azureB2C: {
            clientId: "e33893c0-50dd-482c-b51c-e8c3f460f534",
            tenant: "checkventoryadb2c", // B2C tenant name
            tenantDomain: "checkventoryadb2c.onmicrosoft.com",
            signInFlow: "B2C_1_SIGN_IN", // Modern interactive sign-in flow
            resetPasswordFlow: "B2C_1_password_reset_ng",
            editProfileFlow: "B2C_1_edit_profile" // Optional
        },
        passwordReset: {
            params: passwordResetParams,
            redirectUri: "https%3A%2F%2Fauditor.checkventory.com",
            url: "https://checkventoryadb2c.b2clogin.com/checkventoryadb2c.onmicrosoft.com/oauth2/v2.0/authorize"
        },
        powerBI: {
            dashboard: {
                reportId: "e9a65a5c-8475-422c-afda-c9d843a46c06",
                datasetId: "468fa69a-84b2-4c7b-b0f1-564d8739915a"
            },
            reports: [
                {
                    label: "Audit Overview",
                    tabValue: 0,
                    visuals: null,
                    reportId: "6e68a07d-a305-4140-8660-9a079da5bdea",
                    datasetId: "88ea4685-d6a5-4568-8b01-da892b157fa3"
                },
                {
                    label: "Audit Details",
                    tabValue: 1,
                    visuals: "1eca8f17606510224adb",
                    reportId: "ae3e7064-4f2a-4334-8454-fba76a36d856",
                    datasetId: "88ea4685-d6a5-4568-8b01-da892b157fa3"
                },
                {
                    label: "Org Orientation",
                    tabValue: 2,
                    visuals: null,
                    reportId: "7c0e70f2-82a5-4442-9c0f-11dc3cd63181",
                    datasetId: "0259ce57-eb00-4730-9977-1a2afaf4282f"
                },
                {
                    label: "Asset Lookup",
                    tabValue: 3,
                    visuals: null,
                    reportId: "967ab25d-3699-4f3d-a446-a2783d7134f1",
                    datasetId: "af5182c5-20bc-4dfb-a612-e1db240d7c2c"
                },
                {
                    label: "Funder Connect",
                    tabValue: 4,
                    visuals: null,
                    reportId: "41dc49f7-9357-49e5-a0de-7229aa7992c4",
                    datasetId: "d2db84c9-3a72-4023-a7dd-412c013d51d3"
                },
                {
                    label: "Audit Outcome",
                    tabValue: 5,
                    visuals: null,
                    reportId: [
                        "3e3f7340-b26d-4d97-b537-7fc772b46f0b",
                        "47e0a567-66f7-445d-8d23-3e5a609ade2e"
                    ],
                    datasetId: "1e83e7f0-6ea5-46ad-999d-694ae8804f0c",
                    send_identities: false
                },
                {
                    label: "atRiskAsset",
                    tabValue: 6,
                    visuals: null,
                    reportId: "6dfcf9b6-574f-4368-b001-bb302f74b9ce",
                    datasetId: "a996f60f-e033-4e24-8f86-d76a56661d04"
                }
            ],
            operations: [
                {
                    label: "Onboarding",
                    tabValue: 0,
                    visuals: null,
                    reportId: "4d623578-4e48-42c1-bad5-612c47290bb4",
                    datasetId: "3ee28458-26d6-4005-8695-de73ae617724"
                },
                {
                    label: "Service Performance",
                    tabValue: 1,
                    visuals: "a9b8190c3b91610dbc2c",
                    reportId: "e3dc5b76-a161-4665-86cd-97a70540e34d",
                    datasetId: "4ff5e54e-fcbc-47cc-803a-085818f998f0"
                },
                {
                    label: "Billing",
                    tabValue: 2,
                    visuals: null,
                    reportId: "714b5d2d-43aa-4c70-b209-cb6df1ae8346",
                    datasetId: "f0fb0f1f-2506-4652-b4b1-0a604b598d6a"
                },
                {
                    label: "Audit Performance",
                    tabValue: 3,
                    visuals: "80e97afa6bedaf74b2d6",
                    reportId: "1a0e8fa8-8b57-46cd-aa7f-9619242fa121",
                    datasetId: "0449e22c-7371-42ca-9c94-1d12f0fd2c57"
                },
                {
                    label: "Compliance",
                    tabValue: 4,
                    visuals: "1eca8f17606510224adb",
                    reportId: "d146882e-473b-448a-95a8-bb8c57e3fa8a",
                    datasetId: "88ea4685-d6a5-4568-8b01-da892b157fa3"
                },
                {
                    label: "Invoice",
                    tabValue: 5,
                    visuals: null,
                    reportId: "1883cb26-ba84-467b-b95f-bd9fa988c941",
                    datasetId: "6a30184f-e5d4-4d86-bd75-21540df26b12"
                }
            ],
            funderCheck: {
                reportId: "f71f4d54-b2d8-4675-899b-6c96904fd053",
                datasetId: "b4fc11df-a6d7-4483-9cf2-56b7b7e9c49d"
            }
        },
        supportEmail: "support@checkventory.com"
    }
};

export default checkVentory;
